import vmClient from 'app/services/vmClient';
import { Entity, EntityStringId, IEntityType, IEntity } from 'app/types/entity';
import { Language, LanguageMarshaller } from 'app/constants/enums/Language';

export interface IWordTranslation extends IEntity {
  attributes: {
    id: EntityStringId;
    iknowItemId: number | null;
    iknowGoalId: number | null;
    language: Language;
    translations: string[];
  };
}

export type WordTranslation = Entity<IWordTranslation>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WordTranslation: IEntityType<IWordTranslation> = vmClient.defineClass({
  typeName: 'WordTranslation',
  version: 3,
  lockable: true,
  persisted: true,
  attributes: {
    iknowItemId: 'number',
    iknowGoalId: 'number',
    language: {
      type: Language,
      marshaller: LanguageMarshaller,
      notNull: true,
    },
    translations: {
      type: 'string',
      notNull: true,
      collection: true,
    },
  },
});
